import { render, staticRenderFns } from "./WhatIfControl.vue?vue&type=template&id=61f14e3d&scoped=true"
import script from "./WhatIfControl.vue?vue&type=script&lang=js"
export * from "./WhatIfControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f14e3d",
  null
  
)

export default component.exports